namespace Gamification.Gamification {
    export interface UtentiDelegatiConProprietaRow {
        IdUtenteDelegato?: number;
        UserId?: number;
        UserIdDelDelegato?: number;
        AdminUsername?: string;
        AdminDisplayName?: string;
        UserUserName?: string;
        UserDisplayName?: string;
        Cognome?: string;
        Nome?: string;
        Email?: string;
        RagioneSociale?: string;
    }

    export namespace UtentiDelegatiConProprietaRow {
        export const idProperty = 'IdUtenteDelegato';
        export const nameProperty = 'AdminUsername';
        export const localTextPrefix = 'Gamification.UtentiDelegatiConProprieta';
        export const lookupKey = 'Gamification.UtentiDelegatiConProprieta';

        export function getLookup(): Q.Lookup<UtentiDelegatiConProprietaRow> {
            return Q.getLookup<UtentiDelegatiConProprietaRow>('Gamification.UtentiDelegatiConProprieta');
        }
        export const deletePermission = 'Gamification:Utenti';
        export const insertPermission = 'Gamification:Utenti';
        export const readPermission = 'Gamification:Utenti';
        export const updatePermission = 'Gamification:Utenti';

        export declare const enum Fields {
            IdUtenteDelegato = "IdUtenteDelegato",
            UserId = "UserId",
            UserIdDelDelegato = "UserIdDelDelegato",
            AdminUsername = "AdminUsername",
            AdminDisplayName = "AdminDisplayName",
            UserUserName = "UserUserName",
            UserDisplayName = "UserDisplayName",
            Cognome = "Cognome",
            Nome = "Nome",
            Email = "Email",
            RagioneSociale = "RagioneSociale"
        }
    }
}
